// FIXME
// useEffect(() => {
//     info('useEffect progress from remainingSteps')
//     if (params.assessmentParams['Remaining steps']) {
//         const remainingSteps = levenshtein(
//             array2str(assignations.map((a) => a?.bucket ?? 0)),
//             REF_GAUSSIAN_STR
//         )
//         const progress =
//             ((assignations.length - remainingSteps) / assignations.length) *
//             100
//         setState((prevSt) => ({ ...prevSt, progress, remainingSteps }))
//     } else {
//     }
// }, [assignations, params])

import { useEffect } from 'react'
import { FSM_STATES, FSM_STATE_TYPE } from '../../context/defaultState'
import { AsgnStateType, GLOBAL_STATE_TYPE } from '../../context/types'
import { info } from '../../services/sentryLogger'
import { PartialParameters } from '../../parameters/types'
import { AnswserScoreType, NO_SCORE } from '../../services/types'

const AVG_COMPARISONS_PER_STM = 2.5
const AVG_TIME_PER_COMPARISON = 6.5
const AVG_TIME_PER_ROUND_CONFIRM = 20
const AVG_TIME_PER_BUCKET = 3
export const MAX_BUCKET_RANKING = 6
const AVG_TIME_PER_BUCKET_RANKING = 7.5
const AVG_TIME_FOR_OVERVIEW = 20

export const getFlags = (fsmState: FSM_STATE_TYPE) => {
    const isRanking = [
        FSM_STATES['RANK_14_X_BY_X'],
        FSM_STATES['RANK_FOR_PROFILE'],
    ].includes(fsmState)

    const howTos = [
        FSM_STATES['HOW_TO_BINARY'],
        FSM_STATES['HOW_TO_BUCKETS'],
        FSM_STATES['HOW_TO_360'],
        FSM_STATES['AWARD_ROUND'],
    ].includes(fsmState)

    const isConfirming = [
        FSM_STATES['RANK_FOR_ROUND'],
        FSM_STATES['RANK_FOR_PROFILE'],
    ].includes(fsmState)

    const hasDoneComparisons = [
        FSM_STATES['RANK_FOR_ROUND'],
        FSM_STATES['RANK_FOR_BUCKET'],
        FSM_STATES['FINAL_OVERVIEW'],
    ].includes(fsmState)

    // FIXME idem above
    const hasDoneRoundsConfirmations = [
        FSM_STATES['RANK_FOR_BUCKET'],
        FSM_STATES['RANK_FOR_BUCKET'],
        FSM_STATES['FINAL_OVERVIEW'],
    ].includes(fsmState)

    const hasDoneBuckets = [FSM_STATES['FINAL_OVERVIEW']].includes(fsmState)

    const isStateWSortableList = [
        FSM_STATES.RANK_FOR_ROUND,
        FSM_STATES.RANK_FOR_PROFILE,
    ].includes(fsmState)

    const isStateWithoutProfile = [
        FSM_STATES.RANK_FOR_BUCKET,
        FSM_STATES.FINAL_OVERVIEW,
    ].includes(fsmState)

    return {
        isRanking,
        isConfirming,
        hasDoneComparisons,
        hasDoneRoundsConfirmations,
        hasDoneBuckets,
        isStateWSortableList,
        howTos,
        isStateWithoutProfile,
    }
}

export const useProgress = (
    state: AsgnStateType,
    scannedItems: AnswserScoreType[],
    setState: React.Dispatch<React.SetStateAction<GLOBAL_STATE_TYPE>>,
    stmsSize: number
) => {
    useEffect(() => {
        setState((prevState: GLOBAL_STATE_TYPE) => {
            const { remainingSteps, remainingTime, progress, progresses } =
                updateRemainingSteps(state, scannedItems, stmsSize) // FIXME restore
            // useEffect(() => {
            //     if (params.assessmentParams['Remaining steps']) {
            //         const remainingSteps = levenshtein(
            //             array2str(assignations.map((a) => a?.bucket ?? 0)),
            //             REF_GAUSSIAN_STR
            //         )
            //         const progress =
            //             ((assignations.length - remainingSteps) / assignations.length) *
            //             100
            //         setState((prevSt) => ({ ...prevSt, progress, remainingSteps }))
            //     } else {
            //     }
            // }, [assignations, params])
            // info(
            //     'useEffect updateRemainingSteps()',
            //     prevState.fsmState,
            //     {
            //         ...prevState,
            //         ...rest,
            //         remainingTime,
            //         remainingSteps,
            //         progress,
            //     }
            // )
            return {
                ...prevState,
                remainingSteps,
                remainingTime,
                progress,
                progresses,
            }
        })
    }, [
        state.currentStmIndex,
        state.currentRound,
        state.currentBucket,
        state.currentBucketRanking,
        state.fsmState,
    ])
}

export const updateRemainingSteps = (
    state: AsgnStateType & { params: PartialParameters },
    scannedItems: AnswserScoreType[],
    stmsSize: number
) => {
    const {
        fsmState,
        currentRound,
        currentStmIndex,
        currentBucket,
        currentBucketRanking,
        params,
    } = state
    const {assessmentParams: { is360 = false } } = params
    const stmIndex360 = scannedItems.filter((a: AnswserScoreType) => a.Score !== NO_SCORE).length;
    const stmsPerRound = params.assessmentParams['Nb of values']
    const stmsPerRoundCompared = stmsPerRound - 1
    const nBuckets = params.assessmentParams['Buckets']
    const nBucketRanking = MAX_BUCKET_RANKING
    const nbRounds = params.assessmentParams['Nb of rounds']
    const {
        isRanking,
        hasDoneComparisons,
        hasDoneRoundsConfirmations,
        hasDoneBuckets,
    } = getFlags(fsmState)

    let roundIndex = currentRound - 1
    // const bucketIndex = currentBucket - 1
    let remainingStms =
        stmsPerRoundCompared - currentStmIndex - (hasDoneComparisons ? 1 : 0)
    let remainingRoundsForStm = nbRounds - currentRound
    let remainingRounds2Confirm =
        nbRounds - roundIndex - (hasDoneRoundsConfirmations ? 1 : 0) // w
    // const remainingBucketsToConfirm =
    //     nBuckets - bucketIndex - (hasDoneBuckets ? 1 : 0) //includes the current one

    let remainingStms2finish =
        remainingStms + stmsPerRoundCompared * remainingRoundsForStm
    let remainingComparisons = remainingStms2finish * AVG_COMPARISONS_PER_STM

    if (hasDoneRoundsConfirmations) {
        remainingRounds2Confirm = 0
        remainingStms = 0
        remainingStms2finish = 0
        remainingComparisons = 0
    }

    let remainingBucketsToRank =
        nBucketRanking - currentBucketRanking - (hasDoneBuckets ? 1 : 0)
    if (hasDoneBuckets) {
        remainingBucketsToRank = 0
    }
    let remainingOverview = 0
    const remainingSteps =
        remainingComparisons +
        remainingRounds2Confirm +
        // remainingBucketsToConfirm +
        remainingBucketsToRank +
        remainingOverview
    const maxSteps =
        nbRounds * stmsPerRoundCompared * AVG_COMPARISONS_PER_STM +
        nbRounds +
        // nBuckets +
        nBucketRanking +
        remainingOverview
    const remainingTime =
        remainingComparisons * AVG_TIME_PER_COMPARISON +
        remainingRounds2Confirm * AVG_TIME_PER_ROUND_CONFIRM +
        // remainingBucketsToConfirm * AVG_TIME_PER_BUCKET +
        remainingBucketsToRank * AVG_TIME_PER_BUCKET_RANKING +
        remainingOverview * AVG_TIME_FOR_OVERVIEW

    const progress = 100 - (remainingSteps / maxSteps) * 100
    //
    let r1 = 0,
        r2 = 0,
        r3 = 0,
        fr = 0
    if (!hasDoneComparisons) {
        switch (currentRound) {
            case 1:
                r1 = (currentStmIndex / stmsPerRoundCompared) * 100
                break
            case 2:
                r1 = 100
                r2 = (currentStmIndex / stmsPerRoundCompared) * 100
                break
            case 3:
                r1 = 100
                r2 = 100
                r3 = (currentStmIndex / stmsPerRoundCompared) * 100
                break
        }
    }

    if (fsmState === FSM_STATES['RANK_FOR_BUCKET']) {
        r1 = 100
        r2 = 100
        r3 = 100
        fr = (currentBucketRanking / nBucketRanking) * 100
    }
    if (fsmState === FSM_STATES['FINAL_OVERVIEW']) {
        r1 = 100
        r2 = 100
        r3 = 100
        fr = 100
    }
    const progresses = [r1, r2, r3, fr]
    const output = {
        isRanking,
        hasDoneComparisons,
        hasDoneBuckets,
        currentRound,
        nbRounds,
        currentStmIndex,
        stmsPerRound,
        currentBucket,
        nBuckets,
        remainingStms,
        remainingRounds2Confirm,
        remainingRoundsForStm,
        // remainingBucketsToConfirm,
        remainingStms2finish,
        remainingComparisons,
        remainingSteps,
        maxSteps,
        progress: is360 ? ((stmIndex360 + 1) / stmsSize) * 100.0 : progress,
        progresses,
        remainingTime,
        // remainingBucketsToConfirm,
        remainingBucketsToRank,
        remainingOverview,
    }
    info(
        'updateRemainingSteps',
        {
            fsmState,
            currentStmIndex,
            stmsPerRound,
            stmsPerRoundCompared,
            currentRound,
            nbRounds,
            currentBucket,
            nBuckets,
        },
        output
    )
    return output
}
